import React from 'react';
import { TaskLink } from '../../types/tasks';
import { useOptionalTasks } from '../../context/TasksContext';
import TaskIcon from './TaskIcon';
import '../../tasks.css';

/**
 * "Add task" on a record (product, input, PO, order). Opens the composer
 * with the task already linked back to the record, so the item on the list
 * is one tap from what it's about.
 */
const AddTaskButton: React.FC<{ link: TaskLink; text?: string; className?: string }> = ({ link, text, className = '' }) => {
  const tasks = useOptionalTasks();
  if (!tasks?.ready) return null;
  return (
    <button
      type="button"
      className={`tk-add-task-btn ${className}`}
      onClick={() => tasks.openComposer({ link, text })}
      title="Add a task about this"
    >
      <TaskIcon name="list" size={14} /> Add task
    </button>
  );
};

export default AddTaskButton;
